
export default [
    {
        path: '/dataList/companyLeave',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '请假记录',
            keepAlive: false
        }
    },
];
  